import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

export default function SEO({ title, description, keywords, image, url, type, schema }) {
    const siteUrl = 'https://chatiqchat.com';
    const finalUrl = url ? `${siteUrl}${url}` : siteUrl;
    const finalImage = image ? `${siteUrl}${image}` : `${siteUrl}/logo192.png`; // Fallback image

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title ? `${title} | ChatIQ` : 'ChatIQ - Secure Modern Messaging'}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords.join(', ')} />
            <link rel="canonical" href={finalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={finalImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={finalUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={finalImage} />

            {/* Structured Data (JSON-LD) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
}

SEO.defaultProps = {
    title: 'ChatIQ - Secure Modern Messaging',
    description: 'ChatIQ offers secure, end-to-end encrypted messaging, voice calls, and video calls. Experience privacy-first communication with a modern, intuitive interface.',
    keywords: ['Secure Chat', 'Encrypted Messaging', 'Video Calls', 'Audio Calls', 'Privacy', 'ChatIQ', 'Web App', 'PWA'],
    image: null,
    url: null,
    type: 'website',
    schema: null
};

SEO.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string),
    image: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
    schema: PropTypes.object
};
